import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "600 word essay on the positive merits of politeness",
  "description": "",
  "published": "2010-11-02T00:00:00.000Z",
  "redirect_from": ["/blog/600-word-essay-on-the-positive-merits-of-politeness/swizec/1485"],
  "categories": "Essay, Oscar Wilde, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/File:Pary%C5%BC_p%C3%A8re-lachaise_wilde.JPG"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/11/300px-Pary%C5%BC_p%C3%A8re-lachaise_wilde.jpg",
              "alt": "The tomb of Oscar Wilde in Père Lachaise Cemetery",
              "title": "The tomb of Oscar Wilde in Père Lachaise Cemetery"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/File:Pary%C5%BC_p%C3%A8re-lachaise_wilde.JPG"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`I wrote this as a trade to get pictures of boobs, just so you know.`}</p>
    <blockquote>
      <p parentName="blockquote">{`"One should never do anything that one cannot talk about after dinner." ~Oscar Wilde`}</p>
    </blockquote>
    <p>{`This entire essay could be composed solely out of Oscar Wilde quotes, but that would be missing the point and I probably would not get my just reward for this 2AM rumination on the merits of politeness.`}</p>
    <p>{`But I shall sprinkle my words with Oscar Wilde as generously as I can get away with.`}</p>
    <p>{`That. Is my politeness.`}</p>
    <p>{`My dedication to this essay.`}</p>
    <p>{`And to getting those pics.`}</p>
    <p>{`Perhaps the best way to start an essay about politeness from the perspective of someone who has been neglecting the artistic and the beautiful side of life for much too long and has lost much of his way with words ... is to define what "polite" even means in the first place.`}</p>
    <p>{`"Politeness is best expressed as the practical application of good manners or etiquette", as dear old Wikipedia has to say.`}</p>
    <p>{`Rubbish, that tells us nothing, just gives us two more wishy-washy terms to define. Ones that even within a single society are impossible to pinpoint. Just in my long lifetime of 21 years the rules of etiquette have changed significantly.`}</p>
    <p>{`When I started life the only well mannered thing to do was to take care you did not somehow manage to miss the diaper and I'm told, while utterly disgusting, pising all over your parents when they are changing you does not even begin to be ill mannered - it is even full of wit.`}</p>
    <p>{`Nowadays if I but imply that I am a gentleman, women laugh and call me lewd.`}</p>
    <p>{`So that definition is useless.`}</p>
    <p>{`Perhaps if we try with a little Wilde again: "The terror of society, which is the basis of morals, the terror of God, which is the secret of religion -- these are the two things that govern us."`}</p>
    <p>{`Ah!`}</p>
    <p>{`That becomes slightly more useful then does it not? We can now figure that politeness is some kind of selective function in the evolutionary algorithm of our behaviour. An uneducated person first tries to do or say a thing, if the outcome is favourable said behaviour is then reinforced, if the outcome is less than favourable the behaviour is lessened and eventually it goes away.`}</p>
    <p>{`This then makes politeness an immesuarable discrete function of actions. We can observe it by measuring the median of the correlating discrete function of responses, which should in theory turn out to be a roughly sinusoidal function limiting to some sort of commonly defined moving average of positive responses.`}</p>
    <p>{`Sort of.`}</p>
    <p>{`Now that we know what we are talking about it becomes quite easy to discern what the positive merits of being polite are - positive responses!`}</p>
    <p>{`In general this should mean that when a person is polite it should be easier for them to achieve the attended goal of specific interactions with another.`}</p>
    <p>{`But: "To be good, according to the vulgar standard of goodness, is obviously quite easy. It merely requires a certain amount of sordid terror, a certain lack of imaginative thought, and a certain low passion for middle-class respectability." ~ Oscar Wilde`}</p>
    <p>{`And experience does often teach us that the exact opposite of being polite creates more success than being polite does. People do not like boring. People do not NOTICE boring. Boring is lame. Politely boring is horrible.`}</p>
    <p>{`When striving to achieve something one should be as far from polite as possible. Carefully frollicking on the line of appropriateness lies the key to success. And that is an order of magnitude worse than touching the politeness line. Oh yes!`}</p>
    <p>{`Please stop being polite. Only Americans want to be polite.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=67604c46-7e93-417b-89d6-0d0cc9db4cea",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      